import { render, staticRenderFns } from "./SignageListCustomItem.vue?vue&type=template&id=58a8090d&"
import script from "./SignageListCustomItem.vue?vue&type=script&lang=js&"
export * from "./SignageListCustomItem.vue?vue&type=script&lang=js&"
import style0 from "./SignageListCustomItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItemTitle})
